import { Link } from "react-router-dom";
import { Phone, FileText, CalendarCheck } from "lucide-react";
import { SITE } from "@/lib/site";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#121212] text-[#F6F3EB] border-t border-[#33353B] shadow-[0_-8px_30px_rgba(0,0,0,0.35)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 divide-x divide-[#242529]">
        <a
          href={SITE.phoneHref}
          data-testid="mobile-bar-call-btn"
          className="flex flex-col items-center justify-center gap-1 py-3 active:bg-[#242529] transition-colors"
        >
          <Phone className="h-5 w-5 text-[#8C7B5D]" />
          <span className="font-mono text-[10px] uppercase tracking-[0.18em]">Appeler</span>
        </a>
        <Link
          to="/devis"
          data-testid="mobile-bar-quote-btn"
          className="flex flex-col items-center justify-center gap-1 py-3 bg-[#8C7B5D] text-[#121212] active:bg-[#7a6a4f] transition-colors"
        >
          <FileText className="h-5 w-5" />
          <span className="font-mono text-[10px] uppercase tracking-[0.18em] font-medium">Devis</span>
        </Link>
        <Link
          to="/contact"
          data-testid="mobile-bar-appointment-btn"
          className="flex flex-col items-center justify-center gap-1 py-3 active:bg-[#242529] transition-colors"
        >
          <CalendarCheck className="h-5 w-5 text-[#8C7B5D]" />
          <span className="font-mono text-[10px] uppercase tracking-[0.18em]">Rendez-vous</span>
        </Link>
      </div>
    </div>
  );
}
